__turbopack_context__.v({
  "clickable": "Xl7Gtq_clickable",
  "imageCarousel": "Xl7Gtq_imageCarousel",
  "partialImages": "Xl7Gtq_partialImages",
  "slide": "Xl7Gtq_slide",
});
